export const InitialState = {
    fullName: '',
    username: '',
    modal: false,
    sizeModal: '',
    titleModal: '',
    typeModal: '',
    hideClose: false,
}